import { useState, useRef, useEffect } from "react";
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, IconButton 
} from "@mui/material";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { CloseIcon } from "yet-another-react-lightbox";

export default function SignatureModal({ open, onClose, setSignatureData, setFileType }) {
  const sketchCanvasRef = useRef(null);
  const [isCanvasEmpty, setIsCanvasEmpty] = useState(true);

  const checkIfCanvasIsEmpty = async () => {
    try {
      const paths = await sketchCanvasRef.current.exportPaths();
      setIsCanvasEmpty(paths.length === 0);
    } catch (error) {
      console.error("Error checking canvas state:", error);
    }
  };

  const getSignatureData = async () => {
    try {
      const signatureData = await sketchCanvasRef.current.exportImage("png");
      setSignatureData(signatureData);
      return signatureData;
    } catch (error) {
      console.error("Error getting digital signature:", error);
      return null;
    }
  };

  const handleClose = ()=>{
    setFileType('')
    onClose()
  }

  const handleSubmit = () => {
    getSignatureData();
    onClose();
  };

  useEffect(() => {
    checkIfCanvasIsEmpty();
  }, []);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Sign Here
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <ReactSketchCanvas
          ref={sketchCanvasRef}
          style={{ width: "100%", height: "300px" }}
          strokeWidth={2}
          strokeColor="black"
          backgroundColor="white"
          onStroke={() => checkIfCanvasIsEmpty()}
        />
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => {
            sketchCanvasRef.current?.clearCanvas();
            setIsCanvasEmpty(true);
          }} 
          variant="outlined"
        >
          Clear Signature
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={isCanvasEmpty}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
